import { logCardClick } from "./log-card-click.js";
export function logContentCardClick(o) {
  return logCardClick(o, !0);
}
